/** Depois que o dono abre a tela do ato, a conferência automática vem em 15 min (tempo para agir). */
export const ACT_FOLLOW_UP_MS = 15 * 60_000;
